import { render } from "./JournalVoucher.vue?vue&type=template&id=144aed20&scoped=true&ts=true"
import script from "./JournalVoucher.vue?vue&type=script&lang=ts"
export * from "./JournalVoucher.vue?vue&type=script&lang=ts"

import "./JournalVoucher.vue?vue&type=style&index=0&id=144aed20&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144aed20"]])

export default __exports__